import React, { useEffect, useState } from "react";
import FormInput from "../FormInput";
import UserInput from "./UserInput";

function UserDataFields({changeUserData}) {
  const [isFilled, setIsFilled] = useState(false);
  const [checkUser, setCheckUser] = useState(false);
  const [isRequired, setIsRequired] = useState(false);

  const userForm = {
    name: {
      id: 1,
      labelName: "Ваше имя",
      value: "",
      type: "text",
    },
    email: {
      id: 2,
      labelName: "Ваш E-mail",
      value: "",
      type: "email",
    },
    phone: {
      id: 3,
      labelName: "Телефон",
      value: "",
      type: "tel",
    },
    message: {
      id: 4,
      labelName: "Сообщение",
      value: "",
      type: "textarea",
    },
  };

  const [userData, setUserData] = useState({
    userName: "",
    userEmail: "",
    userTel: "",
    userMessage: "",
  });

  // const changeUserData = (keyData, valueData) => {
  //   setUserData((prev) => ({ ...prev, [keyData]: valueData }));
  // };

  return (
    <>
      <div style={{display:"none"}}>
        {Object.keys(userForm).map((userInput, index) => {
          let item = userForm[userInput];
          return (
            <UserInput
              key={index + item.id}
              labelName={item.labelName}
              changeUserData={changeUserData}
              dataKey={userInput}
              typeName={item.type}
              inputData={item.value}
              isRequired={isRequired}
              
            />
          );
        })}
        <input id="customFile" type="file" name="user_file" />
      </div>
      {/* <div style={{ marginBottom: "20px", marginTop: "20px" }}>captcha</div> */}
    </>
  );
}

export default UserDataFields;
